export default __webpack_public_path__ + "static/media/After the absence and I, comes consciousness .90db93a6.jpg";